import { render, staticRenderFns } from "./NewRirekishoPreview.vue?vue&type=template&id=da0b5b6e&"
import script from "./NewRirekishoPreview.vue?vue&type=script&lang=js&"
export * from "./NewRirekishoPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports